// services/ftoService.js
// Wired to exact endpoints from FtoController + CoaController.
// Phase 3 Pass 3: added manager+HR endpoints for COA (mirror FTO) and
// unified /dept endpoints for "Show All / Future / YTD / My Schedule".

import api from "../../api";

// ─── FTO ──────────────────────────────────────────────────────────────────────
export const getFtoStats = () => api.get("/fto/stats");
export const getFtoBalances = (empId, year) => api.get("/fto/balances", { params: { empId, year } });
export const getDeptConflicts = (empId, start, end) => api.get("/fto/conflicts", { params: { empId, start, ...(end ? { end } : {}) } });
export const getMyFtoRequests = () => api.get("/fto/my");
export const getAwaitingApproval = () => api.get("/fto/awaiting");
export const getAwaitingHrApproval = () => api.get("/fto/awaiting-hr");

// Server-side paged variants. params: { page, pageSize, q, status }.
// Returns { items, total, page, pageSize }.
export const getAwaitingApprovalPaged = (params) => api.get("/fto/awaiting", { params });
export const getAwaitingHrApprovalPaged = (params) => api.get("/fto/awaiting-hr", { params });
export const getSubordinates = () => api.get("/fto/subordinates");
export const getFtoRequest = (id) => api.get(`/fto/${id}`);
export const submitFto = (payload) => api.post("/fto", payload);
export const updateFto = (id, payload) => api.put(`/fto/${id}`, payload);
export const updateFtoApprovals = (id, payload) => api.patch(`/fto/${id}/approvals`, payload);
export const deleteFto = (id) => api.delete(`/fto/${id}`);

// FTO /dept — Phase 3 Pass 3. One endpoint covers four legacy menus:
//   "Show All FTO's of my Dept"    → getFtoDept()
//   "Show Future FTO's of my Dept" → getFtoDept({ future: true })
//   "Review YTD FTO Status"        → getFtoDept({ year: 2026 })
//   "Show My FTO Schedule"         → getFtoDept({ mine: true })
export const getFtoDept = (params = {}) => api.get("/fto/dept", { params });

// ─── COA ──────────────────────────────────────────────────────────────────────
export const getMyCoaRequests = () => api.get("/coa/my");
export const getCoaRequest = (id) => api.get(`/coa/${id}`);
export const submitCoa = (payload) => api.post("/coa", payload);
export const updateCoa = (id, payload) => api.put(`/coa/${id}`, payload);
export const updateCoaApprovals = (id, payload) => api.patch(`/coa/${id}/approvals`, payload);

// Phase 3 Pass 3 — COA manager+HR (mirror FTO).
//   "Approve COA"                  → getCoaAwaitingApproval()
//   "COAs Awaiting HR Approval"    → getCoaAwaitingHrApproval()
//   "My Subordinates' COAs"        → getCoaSubordinates()
//   "Show All/Future COAs of Dept" → getCoaDept({ future })
//   "Show My COA Schedule"         → getCoaDept({ mine: true })
export const getCoaAwaitingApproval   = () => api.get("/coa/awaiting");
export const getCoaAwaitingHrApproval = () => api.get("/coa/awaiting-hr");

export const getCoaAwaitingApprovalPaged   = (params) => api.get("/coa/awaiting", { params });
export const getCoaAwaitingHrApprovalPaged = (params) => api.get("/coa/awaiting-hr", { params });
export const getCoaSubordinates       = () => api.get("/coa/subordinates");
export const getCoaDept               = (params = {}) => api.get("/coa/dept", { params });

// ─── Schedule (merged from development branch) ─────────────────────────────
export const getMySchedule   = (year) => api.get("/schedule/my",       { params: { year } });
export const getTeamSchedule = (year) => api.get("/schedule/team",     { params: { year } });
export const getEmpSchedule  = (empId, year) => api.get("/schedule/employee", { params: { empId, year } });
export const deleteCoa       = (id)   => api.delete(`/coa/${id}`);
